<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Deslocamento</h3>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoadAll"
            v-on:Reload="onLoadAll">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="onExport">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn :IsText="true" :status="false" :value="moment(obj.dataDeslocamento).format('DD/MM/YYYY')" />
          <TableColumn :IsText="true" :status="false" :value="moment(obj.dataDeslocamento).format('HH:mm:ss')" />
          <TableColumn :IsText="true" :status="false" :value="obj.pessoaNome" />
          <TableColumn :IsText="true" :status="false" :value="obj.gerenteNome" />
          <TableColumn :IsText="true" :status="false" :value="obj.kmRodadoFormatted" />
          <TableColumn :IsText="true" :status="false" :value="obj.valorReembolso" />
        </template>
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import SearchScreen from './search/search.vue'
import ReportVisitasRepository from '@/shared/http/repositories/deslocamento/report.js'

export default {
  name: 'ReportCrm',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: [
        'Data',
        'Hora',
        'Cliente',
        'Gerente',
        'KM',
        'Valor Reembolso'
      ]
    }
  },
  mounted () {
    this.$eventHub.on('Filter', ({ filters }) => {
      this.filters = filters
      this.$refs.tableGrid.Clear()

      this.$nextTick(() => {
        this.onLoadAll()
      })
    })
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {
      if (!this.filters) {
        this.filters = {
          'periodo': null,
          'usuarioId': null
        }
      }

      this.onShowSearch()
    },
    onLoadAll () {
      loading.push()
      ReportVisitasRepository.GetAllDeslocamento(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    async onExport () {
      loading.push()

      await ReportVisitasRepository.GetPdf(this.filters)
        .then((response) => {
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioDeslocamento.pdf'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)

      loading.close()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      let aside = {
        title: 'Filtros',
        self: this,
        component: SearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/deslocamento/ReportDeslocamento.vue